import './AppliedFiltersPanel.scss';

import { Chip } from '@trackman/web-shared-components';
import { ReactComponent as CloseIcon } from 'images/icons/Close.svg';
import { TrackmanEventFiltersType } from 'types/trackmanEvents';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

type Props = {
  onFilterClick: (isSelected: boolean, label: string, filter: TrackmanEventFiltersType) => void;
};

export const AppliedFiltersPanel = observer(({ onFilterClick }: Props) => {
  const tes = useStores().trackmanEventsStore;
  const { t } = useTranslation();

  return (
    <>
      <div className='applied-filters'>
        {Object.entries(tes.eventFilters).map(([key]) => {
          return tes.eventFilters[key].map((filter, index) => {
            const isSelected = tes.eventFilters[key].some((item) => item.label === filter.label);
            return (
              <Chip
                key={`${filter}-${index}`}
                clickable
                label={filter.label}
                icon={<CloseIcon />}
                onClick={() => onFilterClick(isSelected, key, filter)}
              />
            );
          });
        })}
      </div>
      <Chip className='clear-all-filters' clickable label={t('ClearAll', { ns: 'trackmanEvents' })} onClick={() => tes.clearFilters()} />
    </>
  );
});

export default AppliedFiltersPanel;
